module.exports = __webpack_public_path__ + "static/media/close-icon.6279281a.svg";